var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "vs-select",
    {
      staticClass: "w-full",
      attrs: { id: "country-filter", clearable: false, multiple: "" },
      on: { input: _vm.setCountries },
      model: {
        value: _vm.countriesSelect,
        callback: function ($$v) {
          _vm.countriesSelect = $$v
        },
        expression: "countriesSelect",
      },
    },
    [
      _vm._l(_vm.countryOptions, function (item, index) {
        return _c("vs-select-item", {
          key: index,
          attrs: { value: item.value, text: item.text },
        })
      }),
      _c("span", { attrs: { slot: "no-options" }, slot: "no-options" }, [
        _vm._v("Nada que mostrar."),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }